import React, { Component } from 'react';

class FadeModal extends Component {
  constructor(props) {
    super(props);
    this.fadeModal();
  }

  state = {
    showModal: true
  };

  fadeModal = () => {
    setTimeout(() => {
      this.setState(prevState => ({ showModal: !prevState.showModal }));
    }, 1500);
  };

  render() {
    const modal = (
      <div className="fadeModal__outlet">
        <div className="fadeModal__container">{this.props.children}</div>
      </div>
    );

    return this.state.showModal ? modal : null;
  }
}

export default FadeModal;
